import { Factory } from "@/data/dao/Factory";
import { SystemDao } from "@/data/dao/service/SystemDao";
import type { IApiVersion } from "@/data/model/System";
import { Format } from "@/data/util/Format";

import { i18n } from "@/portal/Trans";
import { DataTable, type IDataTableConfig } from "@/portal/elements/DataTable";
import { TableFilter } from "@/portal/elements/TableFilter";

export class ApiVersionTableController {
    private $element: JQuery;
    private dao: SystemDao;
    private dataTable: DataTable<IApiVersion>;
    private search: TableFilter;

    constructor(element: JQuery) {
        this.$element = element;

        this.dao = Factory.getInstance<SystemDao>(SystemDao);

        const tableConfig: IDataTableConfig<IApiVersion> = {
            columnMapping: [
                {
                    name: i18n("general.fields.name"),
                    property: "name",
                    styles: { width: "40%" },
                },
                {
                    name: i18n("apiVersion.fields.version"),
                    property: "version",
                    styles: { width: "20%" },
                },
                {
                    name: i18n("apiVersion.fields.package"),
                    property: "id",
                    styles: { width: "32%" },
                    formatter: (m) => {
                        if (m.package === undefined) return "";

                        return $(
                            '<a href="#">' +
                                i18n("general.download") +
                                " - " +
                                Format.htmlEscape(m.package.name) +
                                "</a>"
                        ).click((e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            location.href = m.package!.path;
                        });
                    },
                },
                {
                    name: "",
                    property: "id",
                    styles: { width: "110px", "text-align": "right" },
                    formatter: () => {
                        return $(
                            '<span><a class="btn btn-sm btn-clean btn-icon btn-icon-md"><i class="la la-edit"></i></a></span>'
                        );
                    },
                },
            ],
            filterProvider: {
                getFilter: () => this.search.getValue(),
                setFilter: (d) => this.search.setValue(d),
            },
            defaultSortAsc: true,
            defaultSortProperty: "version",
        };

        this.search = new TableFilter().appendTo(this.$element.find("> .kt-portlet__body.tablefilter"));
        this.dataTable = new DataTable<IApiVersion>(
            this.$element.find("> .kt-portlet__body > .kt-datatable"),
            this.dao.apiVersionDataSource,
            tableConfig
        );
        this.dataTable.onClick(
            (m) => {
                location.href = "/apiversion/" + m.id;
            },
            (m) => {
                window.open("/apiversion/" + m.id);
            }
        );

        this.dataTable.listenTo(this.search);
    }
}
